import React, { useMemo } from 'react';
import Icon from '../Icon';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import clsx from 'clsx';

const MiniCartIcon = () => {
  const { orderRows, addToCartAnimating = false } = useTypedSelector(
    (state) => state.cart
  );
  const totalOrderRowQuantity = useMemo(
    () => orderRows.reduce((prev, { quantity }) => prev + quantity, 0),
    [orderRows]
  );

  return (
    <>
      {orderRows.length > 0 && (
        <div
          className={clsx(
            'absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-[100%] border-2 border-black text-center font-bold leading-[1.3] text-black transition duration-[125ms] ease-in-out',
            addToCartAnimating && 'scale-150',
            addToCartAnimating ? 'bg-gray-50' : 'bg-white',
            totalOrderRowQuantity > 99 ? 'text-[9px]' : 'text-sm'
          )}
        >
          {totalOrderRowQuantity}
        </div>
      )}
      <Icon
        name="shopping-cart"
        className="text-headerIcon lg:h-6 lg:w-6"
      />
    </>
  );
};

export default MiniCartIcon;
